// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LrHandoverOutlinedSvg from "@fishx/icons-svg/es/asn/LrHandoverOutlined";
import FishxIcon from '../components/FishxIcon';

var LrHandoverOutlined = function LrHandoverOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LrHandoverOutlinedSvg
  }));
};

LrHandoverOutlined.displayName = 'LrHandoverOutlined';
export default React.forwardRef(LrHandoverOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LrHandoverOutlined.js
// module id = 3073
// module chunks = 0